<div class="modal-header">
  <div class="d-flex align-items-center">
    <a (click)="openProfileModal(user)" style="cursor: pointer;" class="back-arrow">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M19 12H5M12 19l-7-7 7-7"/>
      </svg>
    </a>
    <h4 class="modal-title mb-0 ms-2">Contact Setting</h4>
  </div>
  <button type="button" class="btn-close" aria-label="Close" (click)="dismiss('')"></button>
</div>
<div class="modal-body">
  <div class="subContent">
    <div class="row">
      <div class="col-12 bordered">
        <div class="dispFlxSpace-bet mb-3">
                <button shape="round" class="cs_button" (click)="changeCategory('friends')"
                  [class.btn-frnd]="selectedCategory == 'friends'"
                  [class.btn-empty]="selectedCategory != 'friends'">Friends</button>
                <button shape="round" class="cs_button1" (click)="changeCategory('work')"
                  [class.btn-work]="selectedCategory == 'work'"
                  [class.btn-empty]="selectedCategory != 'work'">Work</button>
                <button shape="round" class="cs_button2" (click)="changeCategory('family')"
                  [class.btn-family]="selectedCategory == 'family'"
                  [class.btn-empty]="selectedCategory != 'family'">Family</button>
                <button shape="round" class="cs_button3" (click)="changeCategory('others')"
                  [class.btn-others]="selectedCategory == 'others'"
                  [class.btn-empty]="selectedCategory != 'others'">Others</button>
              </div>
            </div>
            <div class="col-12 pluses">
              <!-- <h1>friends</h1> -->
              <div class="tab-slider--nav">
                <ul class="tab-slider--tabs">
                  <li class="tab-slider--trigger" [class.active]="selectedTab == 'tab1' && selectedCategory=='friends'"
                    [class.active1]="selectedTab == 'tab1' && selectedCategory=='work'"
                    [class.active2]="selectedTab == 'tab1' && selectedCategory=='family'"
                    [class.active3]="selectedTab == 'tab1' && selectedCategory=='others'" rel="tab1"
                    (click)="changeTab('tab1')"> Select Channels </li>
                  <li class="tab-slider--trigger" [class.active]="selectedTab == 'tab2' && selectedCategory=='friends'"
                    [class.active1]="selectedTab == 'tab2' && selectedCategory=='work'"
                    [class.active2]="selectedTab == 'tab2' && selectedCategory=='family'"
                    [class.active3]="selectedTab == 'tab2' && selectedCategory=='others'" rel="tab2"
                    (click)="changeTab('tab2')"> Select Time Slot </li>
                </ul>
              </div>
              <div class="mainContainer" [ngSwitch]="selectedTab" [ngStyle]="{'border':'2px solid #E17538'}">
                <div id="tab1" class="tab-slider--body" *ngSwitchCase="'tab1'">
                  <form>
                    <p *ngFor="let commType of communicationTypes">
                      <label>
                        <input type="checkbox" id="commType.id" (change)="changeChanel(commType.id)"
                          [checked]="commType.checked">
                        <span>{{commType.name}}</span>
                      </label>
                    </p>
                  </form>
                  <!-- <div class="ftr-icon"><ion-icon name="help-circle"></ion-icon><span class="fnt-12">Selecting channel means your allowing or restricting the person how
                        he
                        can
                        contact you.</span></div> -->
                </div>
                <div id="tab2" class="tab-slider--body" *ngSwitchCase="'tab2'">
                  <!-- <p>Pick time according to your convenience</p> -->
                  <div *ngIf="timeSlotType=='Custom'">
                    <div class="row">
                      <div class="col-12 cust-tab">
                        <span (click)="changeTimeSlot('Anytime')" [class.btn-others]="selectedCategory == 'others'"
                          [class.btn-family]="selectedCategory == 'family'"
                          [class.btn-frnd]="selectedCategory == 'friends'"
                          [class.btn-work]="selectedCategory == 'work'">Choose Slots</span>
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col-6">
                        <label>From Time </label>
                        <input type="time" class="form-control" [(ngModel)]="fromTime"
                          [ngModelOptions]="{standalone: true}" />
                      </div>
                      <div class="col-6">
                        <label>To Time </label>
                        <input type="time" class="form-control" [(ngModel)]="toTime"
                          [ngModelOptions]="{standalone: true}" />
                      </div>
                    </div>
                  </div>
                  <div *ngIf="timeSlotType=='Anytime'">
                    <div class="row">
                      <div class="col-md-6 col-lg-6 col-xl-6">
                        <input type="checkbox" (change)="changeTimeSelectionType($event)" /><span class="font-14">
                          Select All </span>
                      </div>
                      <div class="col-md-6 col-lg-6 col-xl-6">
                        <span (click)="changeTimeSlot('Custom')" class="custom-btn"
                          [class.btn-others]="selectedCategory == 'others'"
                          [class.btn-family]="selectedCategory == 'family'"
                          [class.btn-frnd]="selectedCategory == 'friends'"
                          [class.btn-work]="selectedCategory == 'work'">Custom Time</span>
                      </div>
                    </div>
                    <hr>
                    <div class="row mt-2">
                      <div class="col-6 time-left" id="leftPanel">
                        <p *ngFor="let timeSlot of timeSlotsCol1">
                          <input type="checkbox" id="timeSlot.id" [checked]="timeSlot.checked"
                            (change)="markChecked(timeSlot.id)">
                          <span> {{timeSlot.view}}</span>
                        </p>
                      </div>
                      <div class="col-6 time-right" id="rightPanel">
                        <p *ngFor="let timeSlot of timeSlotsCol2">
                          <input type="checkbox" id="timeSlot.id" [checked]="timeSlot.checked"
                            (change)="markChecked(timeSlot.id)">
                          <span> {{timeSlot.view}}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="ftr-icon mt-5"><ion-icon name="help-circle"></ion-icon><span class="fnt-12">Selecting time slot means your allowing or restricting the person at
                        what
                        time they can contact you.</span></div> -->
                </div>
              </div>
            </div>
        </div>
  </div>
  <div class="button-section">
    <div class="row">
      <div class="col-12">
        <div *ngIf="errorMessage && errorMessage.length > 0">
          <p class="red">{{errorMessage}}</p>
        </div>
        <div class="dispFlxSpace-bet">
          <button class="btn cs_button" *ngIf="isSender" (click)="addContact()"
            [class.btn-others]="selectedCategory == 'others'" [class.btn-family]="selectedCategory == 'family'"
            [class.btn-frnd]="selectedCategory == 'friends'" [class.btn-work]="selectedCategory == 'work'">Send Add
            Request</button>
          <button class="btn cs_button" *ngIf="!isSender" (click)="addContact()">Approve</button>
          <button class="btn cs_button" (click)="dismiss('')">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>